import React from "react";
const KS2SectionAAlertInfo = () => {
  return (
    <React.Fragment>
      <div className="row">
        <div className="mb-3 section-number-box">
          <div className="number mr-3 pr-4" />
          <div className="details">
            <div className="form-group form-inline">
              <div className="section-form-group yes-no-box mb-0">
                <p className="fontsize-14 pb-0 mb-0">
                  If you have a savings suspension notice you must show it to your employer to prevent them making KiwiSaver deductions. If you have lost your notice, you can get a replacement online at{" "}
                  <a href="https://www.ird.govt.nz/" target="_blank">
                    <strong>www.ird.govt.nz</strong>
                  </a>{" "}
                  from your myIR account.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="section-box">
          <div className="kr-title">
            <div className="form-check disabled">
              <input className="form-check-input" type="radio" disabled style={{ marginRight: "15px" }} />
              <label className="form-check-label">Section B</label>
            </div>
          </div>
          <div className="personal-details">
            <span className="title pr-3">Personal details</span>
            <div className="blockletterrs-whitebox">
              <div className="blockletterrs-use">Use</div>
              <div>
                <span>B</span>
                <span>L</span>
                <span>O</span>
                <span>C</span>
                <span>K</span>
                <span>L</span>
                <span>E</span>
                <span>T</span>
                <span>T</span>
                <span>E</span>
                <span>R</span>
                <span>S</span>
              </div>
            </div>
          </div>

          <div className="row" style={{ margin: "10px 0 0 40px" }}>
            You must provide your IRD number, name and address.
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default KS2SectionAAlertInfo;
